"use strict";
function doesNotEqualNegativeOneValidator() {
    return function (control) {
        var value = control.value;
        if (value === -1) {
            return { 'doesEqualNegativeOne': true };
        }
        return null;
    };
}
exports.doesNotEqualNegativeOneValidator = doesNotEqualNegativeOneValidator;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/generalValidators.js